function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/***
 * v2版本获取站点信息封装
 * 会将v2版本站点数据格式转换为v1版本
 *
 * 并且当当前域名属于资源方时 会将sid修改为1
 * (这个方式非常依赖配置，本地获取domain的方法需要正确获取对应的origin才能保证正确)
 */
import axios from 'axios';
var siteApi = '/auth/backend/site/v2/detail_by_domain';
var kingUrlMap = {
  local: 'https://api.cloud.wozp.cn',
  dev: 'https://api.cloud.wozp.cn',
  test: 'https://api.cloud.wozp.cn',
  pre: 'https://api-pre.cloud.wozp.cn',
  pro: 'https://api.cloud.wozhipei.com'
};
var Http = axios.create({
  baseURL: kingUrlMap[BUILD_ENV],
  headers: {
    'Content-Type': 'application/json'
  }
});
var allConfig = ['baseInfo', 'domainInfo', 'auxiliary', 'additional', 'platform', 'train', 'career', 'exam', 'school'];

/**
 * 资源方相关的配置项
 */
var merchantKeys = ['merchantDomain', 'merchantMidDomain', 'courseMerchantDomain', 'questionMerchantDomain', 'merchantUserDomain', 'lecturerDomain', 'lecturerMobileDomain', 'merchantUserMobileDomain'];

/**
 * 将v2版本站点信息转换为v1版本
 */
var siteDataTransition = function siteDataTransition(domainUrl, data) {
  var _ref = data || {},
    sid = _ref.sid,
    baseInfo = _ref.baseInfo,
    _ref$configList = _ref.configList,
    configList = _ref$configList === void 0 ? [] : _ref$configList;
  var baseDomain = ['pcDomain', 'wapDomain', 'adminDomain', 'padDomain', 'loginUrl', 'wapLoginUrl', 'portalH5Url', 'merchantDomain', 'signInDomain', 'orgDomain', 'personalDomain', 'midDomain', 'midMobileDomain', 'merchantMidDomain', 'courseMerchantDomain', 'questionMerchantDomain', 'merchantUserDomain', 'lecturerDomain', 'lecturerMobileDomain', 'merchantUserMobileDomain', 'burl'];
  var domainList = [];
  var baseInfoObj = {};
  configList.map(function (configItem) {
    baseDomain.map(function (domainItem) {
      if (configItem.key === domainItem) {
        baseInfoObj[domainItem] = configItem.value;
        domainList.push(configItem.value);
      }
      // 当传入的域名属于资源方，则将sid改为1
      if (merchantKeys.includes(configItem.key) && domainUrl === configItem.value) {
        // 在替换前将sid存入本地，表示资源方的来源sid
        localStorage.setItem('from_sid', data.sid);
        sid = 1;
      }
    });
  });
  var finalData = _objectSpread(_objectSpread({}, data), {}, {
    sid: sid,
    baseInfo: _objectSpread(_objectSpread(_objectSpread({}, baseInfo), baseInfoObj), {}, {
      domainList: domainList,
      sid: sid
    })
  });
  return finalData;
};

/**
 * 获取v2版本站点信息
 */
var getSiteConfigData = function getSiteConfigData(siteParams) {
  var domainUrl = siteParams.domainUrl,
    all = siteParams.all;
  var configTypeList = [];
  if (all) {
    configTypeList = allConfig;
  } else {
    allConfig.map(function (tempKey) {
      siteParams !== null && siteParams !== void 0 && siteParams[tempKey] ? configTypeList.push(tempKey) : '';
    });
  }
  return new Promise(function (resolve, reject) {
    Http.request({
      url: siteApi,
      method: 'post',
      data: {
        configTypeList: configTypeList,
        domain: domainUrl,
        needUserGroup: true
      }
    }).then(function (res) {
      var _ref2 = res || {},
        resData = _ref2.data;
      var data = resData.data;
      // const { data, success } = resData;
      // if (success) {
      //   let finalData = siteDataTransition(domainUrl, data);
      //   resolve(finalData);
      // } else {
      //   resolve(null);
      // }
      if (data) {
        var finalData = siteDataTransition(domainUrl, data);
        resolve(finalData);
      } else {
        resolve(null);
      }
    }).catch(function (err) {
      reject(err);
    });
  });
};
export default getSiteConfigData;